import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = {
  id: "app",
  class: "min-h-screen text-primary font-sans"
}
const _hoisted_2 = { class: "bg-primary text-white" }
const _hoisted_3 = { class: "max-w-page mx-auto px-6 py-16 md:py-20" }
const _hoisted_4 = { class: "grid grid-cols-2 md:grid-cols-12 gap-10 md:gap-12" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"col-span-2 md:col-span-5\"><img src=\"" + _imports_0 + "\" alt=\"Bloqin\" class=\"block h-8 w-auto brightness-0 invert\"><p class=\"mt-5 text-stone/80 text-sm leading-relaxed max-w-sm\"> Gerçek dünya gayrimenkullerini blokzincir üzerinde tokenize ederek erişilebilir, şeffaf ve likit yatırımlar sunan teknoloji girişimi. </p><div class=\"mt-6 flex items-center gap-3\"><a href=\"https://www.linkedin.com/company/bloqin\" target=\"_blank\" rel=\"noopener noreferrer\" aria-label=\"Bloqin LinkedIn\" class=\"w-10 h-10 rounded-full border border-stone/30 flex items-center justify-center text-stone/80 hover:border-secondary hover:text-secondary hover:bg-secondary/5 transition-colors\"><svg class=\"w-4 h-4\" fill=\"currentColor\" viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.852 3.37-1.852 3.601 0 4.267 2.37 4.267 5.455v6.288zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.222 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0z\"></path></svg></a></div></div>", 1)
const _hoisted_6 = { class: "md:col-span-2 md:col-start-7" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", { class: "text-xs font-medium tracking-label uppercase text-secondary" }, "Platform", -1)
const _hoisted_8 = { class: "mt-5 space-y-3 text-sm text-stone/80" }
const _hoisted_9 = { class: "md:col-span-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h4", { class: "text-xs font-medium tracking-label uppercase text-secondary" }, "Şirket", -1)
const _hoisted_11 = { class: "mt-5 space-y-3 text-sm text-stone/80" }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"md:col-span-3\"><h4 class=\"text-xs font-medium tracking-label uppercase text-secondary\">Yasal</h4><ul class=\"mt-5 space-y-3 text-sm text-stone/80\"><li><a href=\"#\" class=\"hover:text-secondary transition-colors\">Gizlilik Politikası</a></li><li><a href=\"#\" class=\"hover:text-secondary transition-colors\">Çerez Politikası</a></li><li><a href=\"#\" class=\"hover:text-secondary transition-colors\">KVKK Aydınlatma Metni</a></li><li><a href=\"#\" class=\"hover:text-secondary transition-colors\">Kullanım Şartları</a></li></ul></div>", 1)
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<details class=\"mt-14 md:mt-16 pt-8 border-t border-stone/10 group\"><summary class=\"cursor-pointer list-none flex items-center justify-between gap-4 text-xs font-medium tracking-label uppercase text-stone/60 hover:text-secondary transition-colors\"><span>Yasal Uyarı</span><span class=\"w-7 h-7 rounded-full border border-stone/30 flex items-center justify-center text-base leading-none group-open:rotate-45 transition-transform\"> + </span></summary><div class=\"mt-5 space-y-3 text-stone/60 text-[13px] leading-relaxed max-w-4xl\"><p> Bu web sitesinde yer alan bilgiler sadece genel bilgilendirme amaçlıdır ve yatırım tavsiyesi niteliğinde değildir. Bloqin, kullanıcılarına tokenize edilmiş gerçek dünya varlıklarına yatırım yapma fırsatı sunar ancak tüm yatırımlar risk içerir ve geçmiş performans gelecekteki sonuçların garantisi değildir. </p><p> Kullanıcılar, Bloqin platformu üzerinden yatırım yapmadan önce kendi araştırmalarını yapmalı ve gerektiğinde profesyonel bir finansal danışmana danışmalıdır. Bloqin, kullanıcıların yatırım kararlarından veya platform üzerinden yapılan işlemlerden doğabilecek kayıplardan sorumlu değildir. </p><p> Platformumuzun sunduğu hizmetler, bulunduğunuz ülkenin finansal düzenlemelerine tabi olabilir. Kullanıcılar, ilgili yasal düzenlemelere uygun hareket etmekten kendileri sorumludur. </p></div></details><div class=\"mt-10 pt-8 border-t border-stone/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-stone/60\"><p> Bloqin bir <a href=\"https://ervteknoloji.com\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-secondary font-medium hover:underline\"> ERV Teknoloji A.Ş. </a> girişimidir. </p><p>© 2026 Bloqin · Tüm hakları saklıdır.</p></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CookieBar = _resolveComponent("CookieBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageHeader),
    _createElementVNode("main", null, [
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("footer", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("ul", _hoisted_8, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/#features",
                  class: "hover:text-secondary transition-colors"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Yatırımlar")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/#how",
                  class: "hover:text-secondary transition-colors"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Nasıl Çalışır")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/#roadmap",
                  class: "hover:text-secondary transition-colors"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Yol Haritası")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/#waitlist",
                  class: "hover:text-secondary transition-colors"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Bekleme Listesi")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("ul", _hoisted_11, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/about",
                  class: "hover:text-secondary transition-colors"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Hakkımızda")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/apply",
                  class: "hover:text-secondary transition-colors"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Birlikte Çalışalım")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/login",
                  class: "hover:text-secondary transition-colors"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Yatırımcı Paneli")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _hoisted_12
        ]),
        _hoisted_13
      ])
    ]),
    _createVNode(_component_CookieBar)
  ]))
}